import { FtTableHeadData } from "components/common/table/FtTable";

export const headData: FtTableHeadData[] = [
  { id: "paymentDate", label: "", alwaysShow: true, sortable: true },
  { id: "paymentMethodName", label: "", sortable: true },
  { id: "amountPaid", label: "", alwaysShow: true, sortable: true },
  { id: "status", label: "", sortable: true },
  { id: "amountDue", label: "", sortable: true },
  { id: "confirmationNumber", label: "", sortable: true },
  { id: "", label: "Action", type: "ACTION" },
];

export const headDataSlider: FtTableHeadData[] = [
  { id: "accountNumber", label: "Account Number", sortable: true },
  { id: "amountDue", label: "", alwaysShow: true, sortable: true },
  { id: "dueDate", label: "", alwaysShow: true, sortable: true },
];
